// extracted by mini-css-extract-plugin
export default {"component":"VrmErrors__component-fb1W","secondLine":"VrmErrors__secondLine-ZPdb"};